const autoSuggest = (router) => {
    console.log("router.query ** autoSuggest", router);
    return fetch(`experience/api/autoSuggest?text=${router.searchText}`).then((response) => response.json())
}
export default autoSuggest;